<template>
  <div class="main">
    <!-- <div :class="['top_box', 'orangeToYellow']">
      <div class="title">阀门状态</div>
      <div>编号：{{ no }}</div>
    </div> -->

    <div class="wrap">
      <div class="row row1">
        <div class="btn btn1" @click="handleProgram">
          <div class="icon">
            <i class="iconfont icon-shezhi1"></i>
          </div>
          <div class="txt">编程</div>
        </div>
        <div class="btn btn1" @click="handleSwitch">
          <div :class="['icon', 'switchBtn', switchValve ? 'on' : 'off']">
            {{ switchValve ? "ON" : "OFF" }}
          </div>
          <div class="txt">{{ switchValve ? "关" : "开" }}阀门</div>
        </div>
      </div>
      <!-- 1 -->
      <div class="row row2 card">
        <div class="top">
          <div class="left">
            <div class="icon">
              <i class="iconfont icon-shuibeng"></i>
            </div>
            <div class="txt">灌溉时间</div>
          </div>
          <div class="right">
            <!-- <div :class="['switch', switchGuan ? 'open' : 'clo']">
              {{ switchGuan ? "已开启" : "未开启" }}
            </div> -->
          </div>
        </div>
        <div class="bottom">
          <div class="left">
            <div class="tit">灌溉持续时间</div>
            <div class="time">{{ autoWork.minute_num }}分钟</div>
          </div>
          <div class="right">
            <div class="tit">已灌溉时间</div>
            <div class="time">{{ startingTime || 0 }}分钟</div>
          </div>
        </div>
      </div>

      <div class="row row3 card">
        <div class="top">
          <div class="left" style="flex:1;">
            <div class="icon">
              <i class="iconfont icon-shuiliuliang"></i>
            </div>
            <div class="txt">流量</div>
          </div>

          <div class="right  flex" style="flex:1;text-align:right;">
            <div style="width:50%;">{{ realTimeFlow || 0 }} ㎥/h</div>
            <div style="width:50%;">{{ totalFlow || 0 }} ㎥</div>
          </div>
        </div>
        <div class="line"></div>

        <div class="top">
          <div class="left">
            <div class="icon">
              <i class="iconfont icon-yali"></i>
            </div>
            <div class="txt">压力</div>
          </div>
          <div class="right">
            <div>{{ pressure || 0 }}MPa</div>
          </div>
        </div>

        <div class="line"></div>
        <div class="top">
          <div class="left">
            <div class="icon">
              <i class="iconfont icon-yali"></i>
            </div>
            <div class="txt">水位</div>
          </div>
          <div class="right">
            <div>{{ fluidLevel || 0 }}m</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 2 -->
    <div class="row row3 card">
      <div class="top">
        <div class="left">
          <div class="icon">
            <i class="iconfont icon-jiangyuliang"></i>
          </div>
          <div class="txt">雨量传感器</div>
        </div>
        <div class="right">
          <div :class="['switch', switchRain ? 'open' : 'clo']">
            {{ switchRain ? "已开启" : "未开启" }}
          </div>
        </div>
      </div>
    </div>

    <div class="row row3 card" v-if="type == 21">
      <div class="top">
        <div class="left">
          <!-- <div class="icon">
              <i class="iconfont icon-jiangyuliang"></i>
            </div> -->
          <div class="txt">日志上传周期</div>
        </div>
        <div class="right">
          <div>{{ cycleDate }} <span>天</span></div>
        </div>
      </div>
    </div>

    <!-- 3 -->
    <div class="row row4 card">
      <div class="top">
        <div class="left">
          <div class="icon">
            <i class="iconfont icon-guanqu"></i>
          </div>
          <div class="txt">自动灌溉</div>
        </div>
        <div class="right">
          <div :class="['switch', switchAuto ? 'open' : 'clo']">
            {{ switchAuto ? "已开启" : "未开启" }}
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="left">
          <div class="tit">启动时间域</div>
          <div class="time">
            {{ autoWork.start_time }}-{{ autoWork.end_time }}
          </div>
        </div>

        <div class="right middle">
          <div class="tit">阀值</div>
          <div class="time">{{ waterGuid }}kpa</div>
        </div>

        <div class="right">
          <div class="tit">水势</div>
          <div class="time">{{ water_flow || "-" }}kpa</div>
        </div>
      </div>
    </div>
    <!-- 4 -->
    <div class="row row4 card">
      <div class="top">
        <div class="left">
          <div class="icon">
            <i class="iconfont icon-naozhong"></i>
          </div>
          <div class="txt">定时灌溉</div>
        </div>
        <div class="right">
          <div :class="['switch', switchTime ? 'open' : 'clo']">
            {{ switchTime ? "已开启" : "未开启" }}
          </div>
        </div>
      </div>
      <div class="autowork">
        <div class="aw_top aw_row aw_row1">
          <div class="tit">灌溉时间</div>
          <div class="times">
            <div class="time_item" v-for="(item, index) in setTimes" :key="index">
              <span>{{ index + 1 }}</span>
              <span>{{ item == "-1:-1" ? "-:-" : item }}</span>
            </div>
          </div>
        </div>
        <div class="aw_middle aw_row aw_row2">
          <div class="tit">偶天数</div>
          <div class="time">{{ isOdd ? "否" : "是" }}</div>
        </div>
        <div class="aw_bottom aw_row aw_row3">
          <div class="tit">每周灌溉</div>
          <div class="time">{{ week }}</div>
        </div>
      </div>
    </div>

    <div v-if="this.type == 21">
      <div class="btn sleep orangeToYellow" @click="handleSleep">设备休眠</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    refreshing: {
      type: Boolean,
      default: false
    },
    type: {
      type: [String, Number],
      default: null
    },
    hasDeviceChange: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      no: null,
      switchValve: false, // 阀门开关
      switchGuan: false, // 灌溉开关
      switchRain: false, // 雨量开关
      switchAuto: false, // 自动开关
      switchTime: false, // 定时开关
      autoWork: {
        end_time: "00:00",
        minute_num: 0,
        start_time: "00:00"
      }, // 自动灌溉信息
      waterGuid: 0, // 水势灌溉指导值 阀值
      water_flow: 0, // 水势值
      isOdd: true, // 是否是基数
      week: "", // 每周几
      setTimes: ["00:00", "00:00", "00:00", "00:00"],
      startingTime: 0, //已灌溉时间
      fluidLevel: 0, //  水位
      realTimeFlow: 0, //  实时流量
      totalFlow: 0, // 总流量
      pressure: 0, // 压力
      cycleDate: 0
    };
  },

  watch: {
    refreshing (val) {
      console.log("监听到刷新:", val);
      val && this.init();
    },

    hasDeviceChange (val) {
      console.log("监听到设备切换:", val);
      this.no = localStorage.getItem("no");
      val && this.init();
    }
  },

  mounted () {
    this.no = localStorage.getItem("no");

    if (!this.no)
      return this.$toast({
        message: `异常：设备号不能为空`,
        duration: 3000
      });

    this.init();
  },

  methods: {
    async init () {
      this.$toast.loading({
        message: "设备读取中...",
        forbidClick: true,
        duration: 0
      });
      await this.getSetting();
      await this.getValveStatus();

      setTimeout(() => {
        this.$toast.clear();
      }, 2000);
    },
    // 读取设置信息
    async getSetting () {
      let apiStr = "rtu_getSetting";
      if (this.type == 21) {
        apiStr = "getGuanGaiKongZhiConfig";
      }

      await this.$api[apiStr](this.no).then(res => {
        if (res.errcode !== 0) {
          return this.$toast({
            message: `读取设置异常:${res.errmsg}`,
            duration: 5000
          });
        }

        const week_cron = this.type == 21 ? res?.data?.weekCron : res?.data?.week_cron;
        const irrigating = this.type == 21 ? {} : res?.data?.irrigating;
        const rainfall_state = this.type == 21 ? res?.data?.rainfallState : res?.data?.rainfall_state;
        const water_potential_threshold = this.type == 21 ? res?.data?.waterPotentialThreshold : res?.data?.water_potential_threshold;
        const water_potential_switch = this.type == 21 ? res?.data?.waterPotentialSwitch : res?.data?.water_potential_switch;
        const timing_switch = this.type == 21 ? res?.data?.timingSwitch : res?.data?.timing_switch;

        const cronArr = week_cron?.split("");
        const first = cronArr[0];
        cronArr.splice(0, 1);

        if (first == 1) {
          this.isOdd = false;
        } else {
          this.isOdd = true;
        }

        let txt = "";
        cronArr.map((o, i) => {
          if (o == 1) {
            txt += `周${this.$noToChinese(i + 1) == "七" ? "日" : this.$noToChinese(i + 1)}  `;
          }
        });

        let setTimes = [];
        if (this.type == 21) {
          this.setTimes.map((o, i) => {
            setTimes.push(res.data?.startTimes[i]?.startTime);
          });
        } else {
          this.setTimes.map((o, i) => {
            setTimes.push(res.data[`start_time_${i + 1}`]?.time);
          });
        }

        this.setTimes = [...setTimes];
        console.log("setTimes:", this.setTimes);
        this.week = txt;
        this.switchAuto = water_potential_switch; //水势开关
        this.switchTime = timing_switch; //定时开关

        if (this.type == 21) {
          this.autoWork = {
            minute_num: res.data?.minuteNum,
            start_time: res.data?.startTime || "00:00",
            end_time: res.data?.endTime || "00:00"
          };
        } else {
          this.autoWork = { ...irrigating };
        }

        this.cycleDate = res.data?.cycleDate;
        this.switchRain = rainfall_state;
        this.waterGuid = water_potential_threshold;

        this.$toast.success({
          message: `读取成功`
        });
      });
    },

    // 读取程序执行状态
    async getValveStatus () {
      let apiStr = "rtu_getValveStatus";
      if (this.type == 21) {
        apiStr = "getGuanGaiKongZhiQiReadValveStatus";
      }

      await this.$api[apiStr]({ gatewayNo: this.no }).then(res => {
        if (res.errcode !== 0) {
          return this.$toast({
            message: `读取状态异常:${res.errmsg}`,
            duration: 5000
          });
        }
        const {
          starting,
          fluidLevel,
          pressure,
          realTimeFlow,
          totalFlow
        } = res.data;
        const valve_status =
          this.type == 21 ? res.data?.valveStatus : res.data?.valve_status;
        const water_flow =
          this.type == 21 ? res.data?.waterFlow : res.data?.water_flow;

        this.realTimeFlow = realTimeFlow; // 实时流量
        this.totalFlow = totalFlow; // 总流量

        this.fluidLevel = fluidLevel; // 水位
        this.pressure = pressure; // 压力
        this.switchValve = valve_status;
        this.water_flow = water_flow
          ? water_flow !== "#"
            ? Number(water_flow)?.toFixed(2)
            : water_flow
          : water_flow;
        this.startingTime = starting;
      });
    },

    // 点击编程
    handleProgram () {
      this.$router.push({
        path: "/rtu_program_program"
      });
    },

    // 操作开关
    async handleSwitch () {
      try {
        const toast = await this.$toast.loading({
          message: this.$t("加载中..."),
          forbidClick: true,
          duration: 0
        });

        let apiStr = "rtu_control";
        if (this.type == 21) {
          apiStr = "setGuanGaiKongZhiQiControl";
        }

        await this.$api[apiStr]({
          // type == 21 的参数
          gatewayNo: this.no,
          switchOn: this.switchValve ? false : true,
          valveNo: 1,
          minuteNum: this.autoWork.minute_num,

          // 11 的参数
          gateway_no: this.no,
          switch_on: this.switchValve ? false : true,
          valve_no: 1,
          minute_num: this.autoWork.minute_num
        }).then(res => {
          if (res.errcode !== 0) {
            return this.$toast({ message: `开关异常:${res.errmsg}`, duration: 5000 });
          }
          console.log("toast:", toast);

          let text = 10;

          let timer = setInterval(() => {
            text--;

            if (text >= 0) {
              toast.message = this.switchValve ? "关闭成功，" : "打开成功，" + `倒计时 ${text} 秒`;
            } else {
              clearInterval(timer);
              this.$toast.clear();
              this.init();
            }
          }, 1000);
        })
          .catch(() => {
            this.$toast.clear();
          });
      } catch (e) {
        console.error(e);
        await this.$toast.clear();
      }
    },

    handleSleep () {
      this.$dialog
        .confirm({ title: "提示", message: "确认将设备休眠吗？" })
        .then(e => {
          console.log("e:", e);
          if (e == "confirm") {
            this.$toast.loading({
              message: "数据发送中...",
              forbidClick: true,
              duration: 0
            });
            this.$api.deviceSleep(this.no).then(res => {
              this.$toast.clear();
              if (res.errcode == 0) {
                this.$toast.success("操作成功");
              } else {
                this.$toast(res.errmsg);
              }
            });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  height: 100%;
  background: #f0f5fc;
}

.top_box {
  height: 80px !important;
  color: #ffffff;
  font-size: 16px !important;
  padding: 10px;
  box-sizing: border-box;

  > .title {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
  }
}

.row1 {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;

  .icon-shezhi1 {
    position: absolute;
    font-size: 26px;
    top: 11px;
    left: 16px;
  }

  .btn1 {
    position: relative;

    &:last-child .txt {
      padding-left: 38px;
    }
  }

  .switchBtn {
    position: absolute;
    top: 1px;
    left: 1px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    height: 51px;
    width: 51px;
    text-align: center;
    line-height: 51px;
    color: #ffffff;
  }

  .on {
    background: linear-gradient(132.98deg, #2ad49a -12.22%, #13b28c 163.13%);
  }

  .off {
    background: #e25c5c;
  }
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  font-size: 16px;
  box-shadow: 0px 10.7278px 31.209px rgba(57, 129, 246, 0.05);
  border-radius: 25.9175px;
  width: 40%;
  height: 52px;
  text-align: center;
}

.card {
  background: #ffffff;
  box-shadow: 0px 10.46px 30.43px rgba(57, 129, 246, 0.05);
  border-radius: 8px;
  padding: 15px;
  box-sizing: border-box;
  margin-bottom: 18px;

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      background: #1e98f6;
      border-radius: 3px;
      color: #ffffff;
      margin-right: 12px;
    }

    .left {
      display: flex;
      // flex: 4;
    }

    .right {
      // flex: 1;
    }

    .txt {
      font-size: 16px;
    }

    .switch {
      border-radius: 101.778px;
      padding: 3px 20px;
      font-size: 12px;
    }

    .open {
      color: #29bc7e;
      background: rgba(27, 224, 141, 0.2);
    }

    .clo {
      background: #fdf8f3;
      color: #edb077;
    }
  }

  .bottom {
    display: flex;
    margin-top: 12px;
    font-size: 16px;

    .left {
      flex: 1;
      text-align: center;
    }
    .right {
      flex: 1;
      border-left: 0.4px solid rgba(111, 126, 168, 0.6);
      text-align: center;
    }

    .tit {
      color: #6f7ea8;
      margin-bottom: 8px;
    }
  }

  .autowork {
    display: block;
    font-size: 16px;

    .left,
    .right,
    .middle {
      width: 100%;
    }
  }

  .aw_row {
    padding: 12px 0;
    border-bottom: 0.4px solid rgba(111, 126, 168, 0.6);

    &:last-child {
      border: none;
    }

    .tit {
      color: #6f7ea8;
      width: 65px;
    }

    .times {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .time_item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50%;
        text-align: center;
        margin-top: 12px;
        white-space: normal;

        span {
          flex: 1;

          &:first-child {
            text-align: right;
          }
        }
      }
    }
  }

  .aw_row2,
  .aw_row3 {
    display: flex;
    align-items: center;

    .time {
      margin-left: 30px;
    }
  }
}

.line {
  width: 100%;
  height: 0.5px;
  background: rgba(111, 126, 168, 0.6);
  margin: 14px 0;
}

.sleep {
  color: #ffffff;
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
}
</style>
